import React, {Component}   from 'react';
import PropTypes            from 'prop-types';
import CheckboxInput        from '../Fields/CheckboxInput';

const checkboxComponents = [];

class AdditionalDetailsMarketingPermissions extends Component {
    constructor(props) {
        super(props);
    }

    /**
     * runs when any of the checkboxes is ticked.
     * if they're all ticked, we call the prop "shouldEnableSubmitButton"
     * with true, otherwise we call it with false
     * @return {[type]} [description]
     */
    toggleCheckbox() {
        let shouldEnableSubmitButton = checkboxComponents
        .filter(c => !window.uornorb(c))
        .every(c => c.state.isChecked);

        // we should mark the submit button as enabled if all
        // our check buttons are ticked
        this.props.shouldEnableSubmitButton(shouldEnableSubmitButton);
    }

    render() {
        let i = 0;
        let checkboxes = this.props.thirdPartyData.payload.checkboxes
        .map(c => {
            i++;
            return (
                <CheckboxInput
                    key={i}
                    fieldName={'thirdParty' + i}
                    source="BaseIndividualApplication"
                    question={[c]}
                    isDefaultChecked={false}
                    callbackFunction={() => this.toggleCheckbox()}
                    ref={c => checkboxComponents.push(c)}
                />
            );
        });

        return(
            <question-row class="header-row">
                <div dangerouslySetInnerHTML={{__html: this.props.thirdPartyData.payload.html}} />
                <br />
                {checkboxes}
            </question-row>
        );
    }
}

AdditionalDetailsMarketingPermissions.propTypes = {
    thirdPartyData : PropTypes.object,
    shouldEnableSubmitButton : PropTypes.func,
};

AdditionalDetailsMarketingPermissions.defaultProps = {
    thirdPartyData: {
        html : "",
        checkboxes : [],
    },
    shouldEnableSubmitButton: () => { return true; },
};

export default AdditionalDetailsMarketingPermissions;


// WEBPACK FOOTER //
// ./src/components/Fragments/AdditionalDetailsMarketingPermissions.js